import React from "react";
import { ForecastTable } from "../Table";

export const Months = () => {
  return <ForecastTable />;
};
